// eslint-disable-next-line import/no-extraneous-dependencies
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        success: '#ADCE6D',
        primary: '#005572',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
